import React, { useEffect, useState } from 'react';

import ImageTopSimilarityFinder from './ImageTopSimilarityFinder';
import ImageProcessingEdgeFxLoader from './ImageProcessingEdgeFxLoader';
import { getImageThumbnail, getImageThumbnailMedium } from '../../../../lib/imageUtilsESM';

/**
 * Modal body that embeds a single image url on the fly — via services/data/fusebox-embed-image,
 * which proxies nlp.rewise.ai/fusebox/embed — and then shows the nearest stored cluster images to
 * that embedding with ImageTopSimilarityFinder in vector mode. Used from the contributions page for
 * fusebox photos, which aren't part of any cluster (and so have no stored embedding) yet.
 *
 * @param {Object} props
 * @param {string} props.imageUrl  the image to embed and search from
 * @param {any}    [props.context] vehicle context of the image, shown alongside the query image
 */
export default function FuseboxEmbedSimilarityModal({ imageUrl, context = null }) {
  const [vector, setVector] = useState(null); // null = still embedding
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    setVector(null);
    setError(null);
    client.service('services/data/fusebox-embed-image').find({ query: { imageUrl: getImageThumbnail(imageUrl, 'm', { skipCloudfront: true }) } })
      .then(res => alive && setVector(res.vector))
      .catch(err => alive && setError(err.toString()));
    return () => { alive = false; };
  }, [imageUrl]);

  if (error) return <div className={'alert alert-danger'}>{error}</div>;
  if (!vector) return <ImageProcessingEdgeFxLoader imageUrl={getImageThumbnail(imageUrl, 'm', { skipCloudfront: true })}  messages={['Checking fusebox structure…', 'Identifiying fuses...', 'Identifying relays…', 'Checking against database…']} />;

  return <ImageTopSimilarityFinder
    queryVector={vector}
    sourceUrl={imageUrl}
    sourceContext={context}
    showControls={true}
    searchOnMount={true}
  />;
}
